/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { SHIPPING_HISTORY_COLS } from './constants'
import { Text } from 'hocs/localization'
import { getPrintedDate, getPrintedDateLocal } from 'utils/date'
import { getFormattedTextOrDefault } from 'utils/printedData'
import Table from 'apps/Table'
import * as styles from './ShippingHistory.scss'

const cx = classNames.bind(styles)

interface IProps {
  t: Text
  subscriptionHistory: []
}

const noValue = () => <div className={styles.noData}>-</div>

const createRefLink = (data) => {
  if (!data.link || !data.num) {
    return noValue()
  }

  const { link, num } = data

  return (
    <a
      className={styles.trackingLink}
      rel='noopener'
      target='_blank'
      href={link}
    >
      {num}
    </a>
  )
}

const createColumnsConfig = t => {
  return [
    {
      title: t(SHIPPING_HISTORY_COLS.items),
      dataKey: SHIPPING_HISTORY_COLS.items,
      cellContentRender: cellData => cellData.join('/n'),
      width: '30%',
    },
    {
      title: t(SHIPPING_HISTORY_COLS.status),
      dataKey: SHIPPING_HISTORY_COLS.status,
      cellContentRender: cellData => t(cellData),
      width: '17%',
    },
    {
      title: t(SHIPPING_HISTORY_COLS.deliveredAt),
      dataKey: SHIPPING_HISTORY_COLS.deliveredAt,
      cellContentRender: getFormattedTextOrDefault(getPrintedDateLocal, noValue),
      width: '30%',
    },
    {
      title: t(SHIPPING_HISTORY_COLS.trackingUrl),
      dataKey: SHIPPING_HISTORY_COLS.trackingUrl,
      cellContentRender: (cellData, row) =>
        getFormattedTextOrDefault(createRefLink, noValue)({ link: cellData, num: row.trackingNumber }),
      width: '23%',
    },
  ]
}

const ShippingHistory: React.SFC<IProps> = ({ t, subscriptionHistory }) => {
  return(
    <div className={cx(styles.tableWrap, 'table-responsive')}>
      <Table columns={createColumnsConfig(t)} data={subscriptionHistory} />
    </div>
  )
}

export default ShippingHistory
